import React from 'react';
import LogoBlack from '../../Admin/logoBlack.png';
import { BookModel } from '../../../interfaces/book.interface';

interface BackCoverPageProps {
  bookData: BookModel | null;
}

const BookBackCoverPage: React.FC<BackCoverPageProps> = ({ bookData }) => {
  return (
    <div
      className="w-[18rem] h-[18rem] md:w-[800px] md:h-[800px] flex flex-col justify-between mx-auto py-4 px-5 items-center rounded font-serif"
      style={{
        backgroundImage: `url("/texture.png")`,
        backgroundSize: 'cover'
      }}
    >
      <div className="flex flex-col items-center gap-6 p-5 md:p-16 md:gap-16">
        <h3 className="text-xl md:text-4xl bold font-yuji-boku">{bookData?.title}</h3>
        <h3 className="text-sm md:text-2xl md:leading-12 font-poppins text-black text-justify">
          {bookData?.summary?.length! > 400
            ? `${bookData?.summary?.slice(0, 400)}...`
            : bookData?.summary}
        </h3>
      </div>
      <div className="w-full flex flex-col justify-center items-center gap-2">
        <img className="h-6 md:h-10 w-auto" src={LogoBlack} alt="Build My Story" />
        <h3>www.buildmystory.com</h3>
      </div>
    </div>
  );
};

export default BookBackCoverPage;
